import { render, staticRenderFns } from "./CommunicationContent.vue?vue&type=template&id=54067eb6&scoped=true"
import script from "./CommunicationContent.vue?vue&type=script&lang=js"
export * from "./CommunicationContent.vue?vue&type=script&lang=js"
import style0 from "./CommunicationContent.vue?vue&type=style&index=0&id=54067eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54067eb6",
  null
  
)

export default component.exports